import {
  FaTachometerAlt, FaTruckLoading, FaTruck, FaClipboardList, FaFileInvoiceDollar,
  FaMoneyBillWave, FaChartPie, FaUserShield, FaUsers, FaWarehouse, FaUserCog, FaBars, FaShoppingCart, FaShippingFast,
  FaBox, FaCalendarAlt, FaCalendarCheck, FaShoppingBag, FaBoxes, FaHandshake, FaShip
} from 'react-icons/fa';
import {
  CALENDAR_RIGHTS,
  CLIENTS_RIGHTS,
  EORDER_RIGHTS,
  FREIGHT_RIGHTS,
  INVOICE_RIGHTS,
  INVENTORY_RIGHTS,
  ITEM_RIGHTS,
  ORDER_RIGHTS,
  PAYMENT_RIGHTS,
  PICKING_RIGHTS,
  PURCHASE_ORDERS_RIGHTS,
  RECEIPT_RIGHTS,
  REPORT_RIGHTS,
  WAREHOUSE_RIGHTS,
} from './utils/moduleRights.js';

export const iconMap = {
  FaTachometerAlt,
  FaTruckLoading,
  FaTruck,
  FaClipboardList,
  FaFileInvoiceDollar,
  FaMoneyBillWave,
  FaChartPie,
  FaUserShield,
  FaUsers,
  FaWarehouse,
  FaUserCog,
  FaBars,
  FaShoppingCart,
  FaShippingFast,
  FaBox,
  FaCalendarAlt,
  FaCalendarCheck,
  FaShoppingBag,
  FaBoxes,
  FaHandshake,
  FaShip
};

export const MENU_INTERNAL = {
  items: [
    { path: '/dashboard', icon: 'FaTachometerAlt', label: 'Dashboard' },
    { path: '/calendar', icon: 'FaCalendarAlt', label: 'Calendar', requiresAnyRights: CALENDAR_RIGHTS },
    { path: '/purchase-orders', icon: 'FaClipboardList', label: 'Purchase Orders', requiresAnyRights: PURCHASE_ORDERS_RIGHTS },
    { path: '/receipts', icon: 'FaTruckLoading', label: 'Warehouse Receipts', requiresAnyRights: RECEIPT_RIGHTS },
    { path: '/orders', icon: 'FaTruck', label: 'Orders', requiresAnyRights: ORDER_RIGHTS },
    { path: '/freight', icon: 'FaShip', label: 'Freight', requiresAnyRights: FREIGHT_RIGHTS },
    { path: '/eorders', icon: 'FaShoppingBag', label: 'eOrders', requiresAnyRights: EORDER_RIGHTS },
    { path: '/clients', icon: 'FaUsers', label: 'Clients', requiresAnyRights: CLIENTS_RIGHTS },
    {
      type: 'group',
      key: 'inventory',
      icon: 'FaWarehouse',
      label: 'Inventory',
      rootPath: '/inventory',
      requiresAnyRights: [...INVENTORY_RIGHTS, ...PICKING_RIGHTS],
      children: [
        { path: '/inventory', icon: 'FaWarehouse', label: 'Inventory', requiresAnyRights: INVENTORY_RIGHTS },
        { path: '/picking-replenishment', icon: 'FaBoxes', label: 'Picking Replenishment', requiresAnyRights: PICKING_RIGHTS },
      ],
    },

    // New group for Items + Bundles
    {
      type: 'group',
      key: 'items',
      icon: 'FaBars',
      label: 'Item / SKUs',
      rootPath: '/items',
      requiresAnyRights: ITEM_RIGHTS,
      children: [
        { path: '/items', icon: 'FaBars', label: 'Item Maintenance', requiresAnyRights: ITEM_RIGHTS },
        { path: '/bundles', icon: 'FaBars', label: 'Bundles', requiresAnyRights: ITEM_RIGHTS },
      ],
    },

    { path: '/warehouse', icon: 'FaWarehouse', label: 'Warehouse', requiresAnyRights: WAREHOUSE_RIGHTS },
    {
      type: 'group',
      key: 'invoices',
      icon: 'FaFileInvoiceDollar',
      label: 'Invoicing',
      rootPath: '/invoices',
      requiresAnyRights: [...INVOICE_RIGHTS, ...PAYMENT_RIGHTS],
      children: [
        { path: '/invoices', icon: 'FaFileInvoiceDollar', label: 'Invoices', requiresAnyRights: INVOICE_RIGHTS },
        { path: '/payments', icon: 'FaMoneyBillWave', label: 'Payments', requiresAnyRights: PAYMENT_RIGHTS },
        { path: '/invoices-periodic', icon: 'FaCalendarAlt', label: 'Periodic Invoicing', requiresAnyRights: ['invoices.create', 'invoices.edit'] },
        { path: '/invoices-weekly', icon: 'FaCalendarAlt', label: 'Weekly Invoicing', requiresAnyRights: ['invoices.create', 'invoices.edit'] },
        { path: '/invoices-monthly', icon: 'FaCalendarCheck', label: 'Monthly Invoicing', requiresAnyRights: ['invoices.create', 'invoices.edit'] },
      ],
    },
    {
      type: 'group',
      key: 'admin',
      icon: 'FaUserShield',
      label: 'Administration',
      rootPath: '/users',
      requiresAdmin: true,
      children: [
        { path: '/server-status', icon: 'FaTachometerAlt', label: 'Server Status' },
        { path: '/appconfig', icon: 'FaUserCog', label: 'App Config' },
        {
          type: 'group',
          key: 'users-admin',
          icon: 'FaUserCog',
          label: 'Users',
          rootPath: '/users',
          children: [
            { path: '/users', icon: 'FaUserCog', label: 'Users' },
            { path: '/role-configuration', icon: 'FaUserShield', label: 'Role Configuration' },
          ],
        },
        { path: '/suppliers', icon: 'FaHandshake', label: 'Suppliers' },
        { path: '/carriers', icon: 'FaTruck', label: 'Carriers' },
        {
          type: 'group',
          key: 'warehouses',
          icon: 'FaWarehouse',
          label: 'Warehouses',
          rootPath: '/warehouse-config',
          children: [
            { path: '/warehouse-config', icon: 'FaWarehouse', label: 'Warehouse Config' },
            { path: '/ftz-sites', icon: 'FaWarehouse', label: 'FTZ Site Config' },
            { path: '/warehouse-designer', icon: 'FaWarehouse', label: 'Warehouse Layouts' },
            {
              type: 'group',
              key: 'warehousefees',
              icon: 'FaMoneyBillWave',
              label: 'Warehouse Fees',
              rootPath: '/templates/warehousefees',
              children: [
                { path: '/templates/warehousefees', icon: 'FaWarehouse', label: 'Storage Fees' },
                { path: '/templates/receiptfees', icon: 'FaTruckLoading', label: 'Receipt Fees' },
                { path: '/templates/orderfees', icon: 'FaTruck', label: 'Order Fees' },
                { path: '/templates/eorderfees', icon: 'FaShoppingBag', label: 'eOrder Fees' },
                { path: '/templates/customfees', icon: 'FaClipboardList', label: 'Custom Fees' },
              ],
            },
          ],
        },
        { path: '/shoppingintegrations', icon: 'FaShoppingCart', label: 'Shopping Integrations' },
        {
          type: 'group',
          key: 'shipping',
          icon: 'FaShippingFast',
          label: 'Shipping',
          rootPath: '/shippingintegrations',
          children: [
            { path: '/shippingintegrations', icon: 'FaShippingFast', label: 'Shipping Integrations' },
            { path: '/shipping-funding', icon: 'FaMoneyBillWave', label: 'Shipping Funding' },
            { path: '/payment-processing', icon: 'FaMoneyBillWave', label: 'Payment Processing' },
            { path: '/shipping-packages', icon: 'FaBox', label: 'Package/Box Definitions' },
          ],
        },
      ],
    },
    { path: '/reports', icon: 'FaChartPie', label: 'Reports', requiresAnyRights: REPORT_RIGHTS },
  ]
};

export const MENU_CLIENT = {
  items: [
    { path: '/dashboard', icon: 'FaTachometerAlt', label: 'Dashboard' },
    { path: '/purchase-orders', icon: 'FaClipboardList', label: 'Purchase Orders', requiresAnyRights: PURCHASE_ORDERS_RIGHTS },
    { path: '/receipts', icon: 'FaTruckLoading', label: 'Warehouse Receipts', requiresAnyRights: RECEIPT_RIGHTS },
    { path: '/orders', icon: 'FaTruck', label: 'Orders', requiresAnyRights: ORDER_RIGHTS },
    { path: '/eorders', icon: 'FaShoppingBag', label: 'eOrders', requiresAnyRights: EORDER_RIGHTS },
    { path: '/items', icon: 'FaBars', label: 'Item / SKUs', requiresAnyRights: ITEM_RIGHTS },
    { path: '/inventory', icon: 'FaWarehouse', label: 'Inventory', requiresAnyRights: INVENTORY_RIGHTS },
    { path: '/invoices', icon: 'FaFileInvoiceDollar', label: 'Invoices', requiresAnyRights: INVOICE_RIGHTS },
    { path: '/reports', icon: 'FaChartPie', label: 'Reports', requiresAnyRights: REPORT_RIGHTS },
  ]
};
